import { IconButton, Menu, MenuItem, MenuList } from '@mui/material'
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state'
import { Fragment } from 'react/jsx-runtime'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import ResetModal from './ResetModal'
import ReopenModal from './ReopenModal'
import { SIZING } from '@common/theme/sizing'
import { SPACING } from '@common/theme/spacing'

export default function PopupMenuList({
  task_id,
  pseudo_id,
  study_id,
}: {
  task_id: string
  pseudo_id: string
  study_id: string
}) {
  return (
    <PopupState variant="popover">
      {(popupState) => (
        <Fragment>
          <IconButton
            {...bindTrigger(popupState)}
            onClick={(e) => {
              popupState.open(e)
              e.stopPropagation()
            }}
          >
            <MoreVertRoundedIcon fontSize="small" data-testid="popup-menu-icon" />
          </IconButton>
          <Menu
            {...bindMenu(popupState)}
            onClick={(e) => e.stopPropagation()}
            anchorOrigin={{
              vertical: 'center',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            data-testid="popup-menu-list"
          >
            <MenuList
              sx={{
                width: SIZING.menuListWidth,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                paddingY: SPACING.spacingSm,
                outline: 'none',
              }}
            >
              <MenuItem
                sx={{
                  width: '100%',
                }}
                data-testid="popup-menu-list-item-reopen"
              >
                <ReopenModal task_id={task_id} pseudo_id={pseudo_id} study_id={study_id} popupState={popupState} />
              </MenuItem>
              <MenuItem
                sx={{
                  width: '100%',
                }}
                data-testid="popup-menu-list-item-reset"
              >
                <ResetModal task_id={task_id} pseudo_id={pseudo_id} study_id={study_id} popupState={popupState} />
              </MenuItem>
            </MenuList>
          </Menu>
        </Fragment>
      )}
    </PopupState>
  )
}
